export default __webpack_public_path__ + "static/media/Principal_Investival2025.b6078e7b.jpg";